import { DEFAULT_CALIFICACION_EVALUACION_DESEMPEÑO, VUETIFY_DATE_FORMAT } from '../../../../const'
import DateAdapter from '../../../../utils/DateAdapter'
import EvaluacionRespetoPrincipios from '../../domain/entities/EvaluacionRespetoPrincipios'

export class RespetoPrincipiosAdapter {
  static toEntity(dto) {
    const entity = new EvaluacionRespetoPrincipios(dto.fk_idPersonalEvaluado)
    entity.id = dto.id
    entity.idEvaluador = dto.fk_idPersonalEvaluador
    entity.evaluador = dto.PersonalEvaluador
    entity.idEvaluado = dto.fk_idPersonal
    entity.evaluado = dto.Personal
    entity.idPeriodicidad = dto.fk_idPeriodicidad
    entity.periodicidad = dto.CatPeriodicidad?.title || ''
    entity.idEstatus = dto.fk_idCatEstatusEvaluacion
    entity.estatus = dto.CatEstatusEvaluacion?.title || ''
    entity.fechaAplicacion = dto.fechaAplicacion
    entity.fechaInicio = dto.fechaInicial
    entity.fechaConclusion = dto.fechaFin
    entity.puntajeTotal = dto.puntajeTotal
    entity.calificacion = dto.calificacion
    entity.observaciones = dto.observaciones
    entity.idResulado = dto.fk_idResultado
    entity.resultado = dto.CatResultado?.title || ''
    entity.reactivos = (dto.frecuenciasMedicion || []).map((fm) => ({
      idReactivo: fm.fk_idReactivoPrincipio,
      idFrecuencia: fm.fk_idCatFrecuencia,
    }))

    return entity
  }

  static toDto(entity) {
    return {
      id: entity.id,
      puntajeTotal: entity.puntajeTotal ?? 0,
      calificacion: entity.calificacion ?? DEFAULT_CALIFICACION_EVALUACION_DESEMPEÑO,
      observaciones: entity.observaciones,
      fechaAplicacion: new DateAdapter(entity.fechaAplicacion, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fechaInicial: new DateAdapter(entity.fechaInicio, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fechaFin: new DateAdapter(entity.fechaConclusion, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fk_idResultado: entity.idResultado ?? 1,
      fk_idPersonalEvaluado: entity.idEvaluado,
      fk_idPersonalEvaluador: entity.idEvaluador,
      fk_idPeriodicidad: entity.idPeriodicidad,
      fk_idCatEstatusEvaluacion: entity.idEstatus ?? 1,
      frecuenciasMedicion: (entity.reactivos || []).map((r) => ({
        fk_idReactivoPrincipio: r.idReactivo,
        fk_idCatFrecuencia: r.idFrecuencia,
      })),
    }
  }
}
